import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function PencilIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12.7 0.3L15.7 3.3C16.1 3.7 16.1 4.3 15.7 4.7L13.9 6.5L9.5 2.1L11.3 0.3C11.7 -0.1 12.3 -0.1 12.7 0.3Z" />
        <path d="M0.3 11.3L8.1 3.5L12.5 7.9L4.7 15.7C4.5 15.9 4.3 16 4 16H1C0.4 16 0 15.6 0 15V12C0 11.7 0.0999999 11.5 0.3 11.3Z" />
      </svg>
    </Icon>
  );
}
